import React from "react";
import {
  Card,
  CardProductName,
  CardRow,
  ProductInfo,
  Row,
  Price,
} from "./SkeletonMarketplaceLoader.styles";

const SkeletonMarketplaceLoader = ({ single }) => {
  const data = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }];

  return single ? (
    <Card>
      <ProductInfo>
        <CardProductName />
        <CardRow>
          <Price />
          <Price />
        </CardRow>
      </ProductInfo>
    </Card>
  ) : (
    <Row>
      {data.map((x) => (
        <Card key={x.id}>
          <ProductInfo>
            <CardProductName />
            <CardRow>
              <Price />
              <Price />
            </CardRow>
          </ProductInfo>
        </Card>
      ))}
    </Row>
  );
};

export default SkeletonMarketplaceLoader;
